import React, { Component } from 'react';
import RoomPrice from './room-price';
import Accordion from 'travco-accordion';
import actions from '../../redux/actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import SearchUtilities from '../../utils/searchUtils';
import { Tooltip } from 'react-tippy';
import update from 'immutability-helper';
import * as ROOMTYPE from '../../utils/enums';
import moment from 'moment';

class RatePrice extends Component {
    constructor(props) {
        super(props);

        let rooms = this.props.rateObject.ratePlan.roomCategory.roomTypes.map((x) => x.name);
        let selectedRoomTypes = new Set(rooms);
        if (selectedRoomTypes.has('Single')){
            selectedRoomTypes.delete('Double for Single Use');
            selectedRoomTypes.delete('Twin for Single Use');
        }    
        if (selectedRoomTypes.has('Double for Single Use')){
            selectedRoomTypes.delete('Twin for Single Use');
        }
        if (selectedRoomTypes.has('Double')){
            selectedRoomTypes.delete('Twin');
        }

        this.state = {
            selectedRoomTypes
        };

        this.onBookingClick = this.onBookingClick.bind(this);
    }

    onRoomTypeSelected(event) {
        const roomTypeName = event.currentTarget.value;
        const {selectedRoomTypes} = this.state;

        switch (true) {
            case roomTypeName === 'Single':
                selectedRoomTypes.add('Single');
                selectedRoomTypes.delete('Double for Single Use');
                selectedRoomTypes.delete('Twin for Single Use');
            break;
                
            case roomTypeName === 'Double for Single Use':
                selectedRoomTypes.add('Double for Single Use');
                selectedRoomTypes.delete('Single');
                selectedRoomTypes.delete('Twin for Single Use');
            break;
            
            case roomTypeName === 'Twin for Single Use':
                selectedRoomTypes.delete('Double for Single Use');
                selectedRoomTypes.delete('Single');
                selectedRoomTypes.add('Twin for Single Use');
            break;
                
            case roomTypeName === 'Double':
                selectedRoomTypes.delete('Twin');
                selectedRoomTypes.add('Double');
            break;

            case roomTypeName === 'Twin':
                selectedRoomTypes.delete('Double');
                selectedRoomTypes.add('Twin');
            break;
        }
        
        this.setState(update(this.state, { selectedRoomTypes: { $set: selectedRoomTypes } }));
    }

    onBookingClick() {
        const {
            settings: { bookingUrl },
            requestHAData: { data: { roomsRequired } } ,
            rateObject: { rateId, adults, children, checkIn }
        } = this.props;

        let optionalRoomType = [];
        let roomsSelected = {...roomsRequired[0]};
        this.state.selectedRoomTypes.forEach((room) => {
            if (room === 'Double for Single Use'){
                optionalRoomType += '&dsuSelected=true';
                roomsSelected['doubleForSingleUse'] = roomsRequired[0]['single'];
                roomsSelected['single'] = 0;
            } 
            if (room === 'Twin for Single Use'){
                optionalRoomType += '&tsuSelected=true';
                roomsSelected['twinForSingleUse'] = roomsRequired[0]['single'];
                roomsSelected['single'] = 0;
            }
            if (room === 'Twin'){
                optionalRoomType += '&twSelected=true';
                roomsSelected['twin'] = roomsRequired[0]['double'];
                roomsSelected['double'] = 0;
            }
            if (room === 'Double'){
                roomsSelected['twin'] = 0;
            }
        });

        let roomsSearched = [];
        for (const [ key, value ] of Object.entries(roomsSelected)) {
            roomsSearched.push(key.toLowerCase() + '=' + value);
        }

        const roomsTypesSelected = roomsSearched.join('&');

        let url =
            bookingUrl +
            '/setup?rid=' +
            rateId +
            '&' +
            roomsTypesSelected +
            optionalRoomType +
            '&st=HA&enq=0&adultOccupancy=' +
            adults +
            '&childrenOccupancy=' +
            children +
            '&checkInTime=' +
            checkIn.checkInTime +
            '&checkOutTime=' +
            checkIn.checkOutTime;

        window.open(url, '_self');
    }

    render() {
        const {
            cancellationText,
            cancellation,
            nonRefundable,
            checkIn,
            freeNights,
            freeNightsText,
            minLengthOfStayText,
            minLengthStay,
            advancedBookingText,
            currencyName,
            additionalCancellationDays,
            roomCategory: { name },
            ratePlan: { boardBasis, roomCategory: { roomTypes }, restrictions }
        } = this.props.rateObject;

        const {selectedRoomTypes} = this.state;

        const {requestHAData} = this.props;
        const helper = new SearchUtilities();

        const grandTotal = roomTypes.reduce((acc, room) => {

            if (selectedRoomTypes.has(room.name)){
                const adultNumber =
                (room.name === 'Double for Single Use' || room.name === 'Twin for Single Use') ? 
                room.adultRate * requestHAData.data.roomsRequired[0].single : 
                room.adultRate * (ROOMTYPE[room.name.toUpperCase()] * requestHAData.data.roomsRequired[0][room.name.toLowerCase()]);

                const child = requestHAData.data.roomsRequired[0].extraBeds > 0 ? room.childRate * requestHAData.data.roomsRequired[0].extraBeds : 0;

                return acc + adultNumber + child;
            }
            return acc;
        }, 0);

        const restrictList = restrictions.nationalities.map((nation, index) => <span className="ts-restrict-list" key={'nation-'+ index}>{nation.name}</span>);
        const cancellationRule = helper.findCancellation(cancellation.cancellationRules, checkIn.checkInTime);

        return (
            <div className="ts-hc-rate">
                <div className="hc-rate-plan">
                    <span className="hc-rate-plan-title">{name}</span>
                    <div className="hc-discount-wrapper">
                        {freeNightsText &&
                        freeNights.length > 0 && <span className="hc-discount">Free Night</span>}
                        {minLengthOfStayText &&
                        minLengthStay.length > 0 && <span className="hc-discount">Min Night Offer</span>}
                        {advancedBookingText &&
                        advancedBookingText.length > 0 && <span className="hc-discount">Early Bird</span>}
                    </div>
                    <div className="hc-action">
                        <span className="hc-price">
                            {new Intl.NumberFormat('en-GB', {
                                style: 'currency',
                                currency: currencyName,
                                currencyDisplay: 'code'
                            }).format(grandTotal)}
                        </span>
                        <button
                            className="travco-btn-primary blue small hc-book-btn"
                            type="button"
                            onClick={this.onBookingClick}>
                            Book
                        </button>
                    </div>
                </div>
                <div className="hc-rate-info">
                    <span>{boardBasis.name}</span>
                    { nonRefundable ? (
                        <span className="warning">Non-refundable</span>
                    ) : (
                        <span>Refundable</span>
                    )}
                    {restrictList.length > 0 && (
                        <Tooltip html={<div>{restrictList}</div>} position="top" animation="fade" arrow distance={15}>
                            <span className="warning">Restricted Nationalities</span>
                        </Tooltip>
                    )}
                </div>

                <Accordion allowMultipleOpen caption>
                    {[
                        <div ref="ts-rate" className="ts-rate-accordion" label="">
                            <RoomPrice
                                rate={this.props.rateObject}
                                roomsRequired={requestHAData.data.roomsRequired[0]}
                                rooms={helper.getRoomTypesSorted(roomTypes)}
                                selectedRooms={this.state.selectedRoomTypes}
                                onRoomTypeSelected={this.onRoomTypeSelected.bind(this)}
                            />
                            <div className="hc-footer">
                                <strong>Cancellation Note: </strong>
                                {!nonRefundable ? (
                                    `${cancellationText} - After 14:30 (UK time) on the ${moment(checkIn.checkInTime)
                                        .subtract(cancellationRule.agentDaysPriorArrival + (typeof additionalCancellationDays === 'undefined' ? 0 : additionalCancellationDays), 'day')
                                        .format('DD/MMM/YYYY')}`
                                ) : (
                                    'Non-Refundable'
                                )}
                            </div>
                        </div>
                    ]}
                </Accordion>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        settings: state.settings,
        requestHAData: state.xml?.requestHAData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RatePrice);
